import { ApplicationUserData } from './application-user-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class StaffData {
  StaffId: string;
  ContactName: string;
  EmailAddress: string;
  Sites: string[];
  SiteDepotIds: string[];
  PhoneNumber: string;
  UserAccount: ApplicationUserData;
  UserCode: string;
  RoleId: string[];
  Roles: string[];
  Claims: string[];
  CanEstimate: boolean;
  QuickId: string;
  EulaAgreedVersion: string;
  Deleted: boolean;
  LastModified: string;
  CompanyPosition: string;
}


